import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Footer from "../Footer";
import { Image, Spinner } from "react-bootstrap";

function Articles() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    document.title = 'Jobbox.one | Articles';
  }, []);

  useEffect(() => {
    axios
      .get("http://51.79.18.21:1337/api/jobboxarticles?populate=*")
      .then((response) => {
        const rawArticles = response.data.data || [];
        setArticles(rawArticles);
      })
      .catch((error) => {
        console.error("Error fetching articles:", error);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      {/* Header with Logo (no bg color) */}
      <header
        style={{
          padding: "16px 40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #eee",
          backgroundColor: "white"
        }}
      >
        <a href="/">
          <Image
            src="/jb_logo.png"
            alt="Jobbox Logo"
            fluid
            style={{
              width: "180px",
              height: "auto",
              cursor: "pointer",
            }}
          />
        </a>
      </header>

      {/* Articles Section */}
      <div
        style={{
          padding: "60px 40px",
          backgroundColor: "#f9fafc",
          minHeight: "100vh",
        }}
      >
        <h1
          style={{
            marginBottom: "40px",
            fontSize: "36px",
            fontWeight: "700",
            textAlign: "center",
            color: "#222",
          }}
        >
          Latest Articles
        </h1>

        {loading ? (
          <div style={{ textAlign: "center", padding: "50px" }}>
            <Spinner animation="border" role="status" />
            <p style={{ marginTop: "12px", color: "#555" }}>
              Loading articles...
            </p>
          </div>
        ) : articles.length === 0 ? (
          <p
            style={{
              textAlign: "center",
              color: "#666",
              fontSize: "18px",
            }}
          >
            No articles found.
          </p>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
              gap: "32px",
            }}
          >
            {articles.map((article) => {
              const imageUrl = article.image?.url
                ? `http://51.79.18.21:1337${article.image.url}`
                : null;

              return (
                <Link
                  to={`/blog/${article.slug}`}
                  key={article.id}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "16px",
                      overflow: "hidden",
                      boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                      transition: "transform 0.25s ease, box-shadow 0.25s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-6px)";
                      e.currentTarget.style.boxShadow =
                        "0 12px 28px rgba(0,0,0,0.12)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 6px 20px rgba(0,0,0,0.08)";
                    }}
                  >
                    {imageUrl && (
                      <img
                        src={imageUrl}
                        alt={article.Title}
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "cover",
                          transition: "transform 0.3s ease",
                        }}
                      />
                    )}
                    <div style={{ padding: "20px" }}>
                      <h3
                        style={{
                          fontSize: "20px",
                          fontWeight: "600",
                          color: "#222",
                          marginBottom: "10px",
                        }}
                      >
                        {article.Title}
                      </h3>
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#666",
                          margin: "0",
                        }}
                      >
                        {article.Subtitle || "Click to read more..."}
                      </p>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default Articles;
